webpackJsonp([9,35],{

/***/ 14:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'switch',
	  props: {
	    showTag: {
	      type: Boolean,
	      default: false
	    },
	    tag: {
	      type: Array,
	      default: function _default() {
	        return ['开', '关'];
	      }
	    },
	    value: {
	      type: Boolean,
	      default: true
	    }
	  },
	  methods: {
	    _handleClick: function _handleClick() {
	      this.stateSelf = !this.stateSelf;
	      this.$emit('on-click', this.stateSelf);
	      this.$emit('input', this.stateSelf);
	    },
	    setState: function setState(state) {
	      this.stateSelf = state;
	    }
	  },
	  computed: {
	    cssState: function cssState() {
	      var state = '';
	      if (this.showTag && !this.stateSelf) {
	        state = 'switch-tag-off';
	      } else if (!this.showTag && !this.stateSelf) {
	        state = 'switch-off';
	      } else {
	        state = 'switch-on';
	      }
	      return state;
	    }
	  },
	  watch: {
	    value: function value(newval) {
	      this.stateSelf = newval;
	    }
	  },
	  data: function data() {
	    return {
	      stateSelf: this.value
	    };
	  }
	};

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(14),
	  /* template */
	  __webpack_require__(18),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "switch",
	    class: [
	      _vm.showTag ? 'switch-tag' : '',
	      _vm.cssState
	    ],
	    on: {
	      "click": _vm._handleClick
	    }
	  }, [(_vm.showTag) ? _c('span', {
	    staticClass: "on"
	  }, [_vm._v(_vm._s(_vm.tag[0]))]) : _vm._e(), _vm._v(" "), (_vm.showTag) ? _c('span', {
	    staticClass: "off"
	  }, [_vm._v(_vm._s(_vm.tag[1]))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _menuVertical = __webpack_require__(13);
	
	var _menuVertical2 = _interopRequireDefault(_menuVertical);
	
	var _boSwitch = __webpack_require__(16);
	
	var _boSwitch2 = _interopRequireDefault(_boSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'test1',
	  components: {
	    menuVertical: _menuVertical2.default,
	    BoSwitch: _boSwitch2.default
	  },
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    path: {
	      type: String,
	      default: ''
	    },
	    dock: {
	      type: String,
	      default: ''
	    },
	    state: {
	      type: Boolean,
	      default: false
	    },
	    alias: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    onclick: function onclick() {
	      this.$emit('on-click', '');
	    },
	    _handleSwitch: function _handleSwitch(data) {
	      var _this = this;
	
	      this.$emit('on-switch', {
	        obj: this,
	        state: data
	      });
	
	      setTimeout(function () {
	        _this.$refs.sw.setState(false);
	      }, 1000);
	    },
	    off: function off() {
	      this.$refs.sw.setState(false);
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'drawer',
	  props: {
	    show: {
	      type: Boolean,
	      default: false
	    },
	    position: {
	      type: String,
	      default: 'center' }
	  },
	  methods: {
	    handleClick: function handleClick() {
	      this.$emit('on-layoutclick', this.show);
	      this.$emit('on-click', this.show);
	    }
	  },
	  data: function data() {
	    return {
	      animate: {
	        center: 'modal',
	        bottom: 'bt',
	        left: 'lr',
	        top: 'tb',
	        'top-header': 'tb'
	      }
	    };
	  }
	};

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(20),
	  /* template */
	  __webpack_require__(35),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(21),
	  /* template */
	  __webpack_require__(33),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 33:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('transition', {
	    attrs: {
	      "name": "layout"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "layout-opacity",
	    class: [_vm.position == 'top-header' ? 'layout-header' : ''],
	    on: {
	      "click": _vm.handleClick
	    }
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": _vm.animate[_vm.position]
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "drawer",
	    class: ['drawer-' + _vm.position]
	  }, [_c('div', {
	    staticClass: "drawer-box"
	  }, [_vm._t("default")], 2)])])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', {
	    attrs: {
	      "path": _vm.path
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "padding-right": "20px"
	    },
	    attrs: {
	      "slot": "dock"
	    },
	    slot: "dock"
	  }, [_c('bo-switch', {
	    ref: "sw",
	    attrs: {
	      "state": _vm.state
	    },
	    on: {
	      "on-click": _vm._handleSwitch
	    }
	  })], 1)])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(117),
	  /* template */
	  __webpack_require__(277),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _drawer = __webpack_require__(28);
	
	var _drawer2 = _interopRequireDefault(_drawer);
	
	var _demoswitch = __webpack_require__(27);
	
	var _demoswitch2 = _interopRequireDefault(_demoswitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'drawerdemo',
	  components: {
	    Drawer: _drawer2.default,
	    Dmenu: _demoswitch2.default
	  },
	  methods: {
	    play: function play(data) {
	      this.show = true;
	      this.pos = data.obj.alias;
	    },
	    close: function close() {
	      this.show = false;
	    }
	  },
	  data: function data() {
	    return {
	      show: false,
	      pos: 'center',
	      state: false
	    };
	  }
	};

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('ul', {
	    staticClass: "list list-box p0002"
	  }, [_c('dmenu', {
	    attrs: {
	      "alias": "center",
	      "name": "Center"
	    },
	    on: {
	      "on-switch": _vm.play
	    }
	  }), _vm._v(" "), _c('dmenu', {
	    attrs: {
	      "alias": "bottom",
	      "name": "Bootom"
	    },
	    on: {
	      "on-switch": _vm.play
	    }
	  }), _vm._v(" "), _c('dmenu', {
	    attrs: {
	      "alias": "left",
	      "name": "Left"
	    },
	    on: {
	      "on-switch": _vm.play
	    }
	  }), _vm._v(" "), _c('dmenu', {
	    attrs: {
	      "alias": "top",
	      "name": "Top"
	    },
	    on: {
	      "on-switch": _vm.play
	    }
	  }), _vm._v(" "), _c('dmenu', {
	    attrs: {
	      "alias": "top-header",
	      "name": "Top with header"
	    },
	    on: {
	      "on-switch": _vm.play
	    }
	  })], 1), _vm._v(" "), _c('drawer', {
	    attrs: {
	      "show": _vm.show,
	      "position": _vm.pos
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "display": "flex",
	      "padding": "40px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-block",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("关 闭")])])])], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.8d58022371794a7becaa.js